import { render, staticRenderFns } from "./relate.vue?vue&type=template&id=281ad39a&scoped=true"
import script from "./relate.vue?vue&type=script&lang=js"
export * from "./relate.vue?vue&type=script&lang=js"
import style0 from "./relate.vue?vue&type=style&index=0&id=281ad39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281ad39a",
  null
  
)

export default component.exports